<template>
  <a-layout-header class="header" theme="light">
    <div class="logo-dashboard" :style="logo">
      <router-link to="/home"></router-link>
    </div>
    <a-menu
      theme="light"
      mode="horizontal"
      :style="{ lineHeight: '64px', background: 'transparent' }"
    >
      <a-menu-item key="1" :style="{ float: 'right' }">
        <a-button
          type="primary"
          :style="{ background: '#11509b', border: 0, borderRadius: 0 }"
        >
          <router-link to="/login">{{ $t('js.dang_nhap') }}</router-link>
        </a-button>
      </a-menu-item>
    </a-menu>
  </a-layout-header>
  <div class="container">
    <a-row class="header-container" type="flex" justify="center">
      <a-col :span="16" class="header-content">
        <a-row type="flex" justify="space-around">
          <a-col :span="8">
            <a-row
              type="flex"
              justify="center"
              align="middle"
              class="header-item"
            >
              <a-col :span="24" class="title-input">
                <span>{{ $t('js.diem_di') }}</span>
              </a-col>
              <a-col :span="24">
                <a-select
                  v-model:value="destinationValue"
                  :options="
                    renderOption(
                      'destination',
                      desLocation,
                      'province_destination_title'
                    )
                  "
                  :placeholder="$t('js.chon_diem_di')"
                  @change="changeDes"
                >
                </a-select>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="8">
            <a-row
              type="flex"
              justify="center"
              align="middle"
              class="header-item"
            >
              <a-col :span="24" class="title-input">
                <span>{{ $t('js.diem_den') }}</span>
              </a-col>
              <a-col :span="24">
                <a-select
                  v-model:value="arrivalValue"
                  :options="
                    renderOption(
                      'arrival',
                      arrLocation,
                      'province_arrival_title'
                    )
                  "
                  :placeholder="$t('js.chon_diem_di')"
                  @change="changeArr"
                >
                </a-select>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="4">
            <a-row
              type="flex"
              justify="center"
              align="middle"
              class="header-item"
            >
              <a-col :span="24" class="title-input">
                <span>{{ $t('js.chon_ngay') }}</span>
              </a-col>
              <a-col :span="24">
                <a-date-picker
                  v-model:value="dateValue"
                  :locale="locale"
                  :format="dateFormat"
                />
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="4">
            <a-row
              type="flex"
              justify="center"
              align="bottom"
              class="header-item"
            >
              <a-col :span="24">
                <a-button @click="getListRoad" type="primary"
                  ><span class="text-search">{{ $t('js.tim_kiem') }}</span></a-button
                >
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row class="content-container" type="flex" justify="center">
      <a-col :span="16" class="content">
        <a-row>
          <a-col :span="18">
            <a-row type="flex" justify="center" class="list">
              <a-col :span="24">
                <a-row type="flex" justify="space-between" align="middle">
                  <a-col>
                    <span class="title">{{ $t('js.sap_xep_theo') }}</span>
                  </a-col>
                  <a-col class="sort-btn"
                    ><a-radio-group
                      v-model:value="sortValue"
                      button-style="solid"
                      @change="sort"
                    >
                      <a-radio-button :value="0">{{ $t('js.gio_som_nhat') }}</a-radio-button>
                      <a-radio-button :value="1">{{ $t('js.gio_muon_nhat') }}</a-radio-button>
                      <a-radio-button :value="2">{{ $t('js.gia_thap_nhat') }}</a-radio-button>
                      <a-radio-button :value="3">{{ $t('js.gia_cao_nhat') }}</a-radio-button>
                    </a-radio-group></a-col
                  >
                </a-row>
              </a-col>
              <a-col
                v-if="dataSource.length == 0 && listLoading == false"
                :span="24"
              >
                <a-row
                  type="flex"
                  justify="center"
                  align="middle"
                  class="list-empty"
                >
                  <a-empty :description="$t('js.khong_co_tuyen_duong_phu_hop')" />
                </a-row>
              </a-col>
              <a-col :span="24" v-if="listLoading" class="list-loading">
                <a-skeleton active />
              </a-col>
              <a-col v-else :span="24" class="list-content">
                <a-row v-for="item in dataSource" :key="item.id">
                  <a-col :span="24">
                    <a-row class="item-list">
                      <a-col :span="24">
                        <a-row
                          :class="[
                            item.is_detail || item.is_select
                              ? 'item-list-content'
                              : '',
                          ]"
                        >
                          <a-col :span="6" class="image-container">
                            <a-row type="flex" align="middle">
                              <a-col>
                                <img
                                  :src="item.path_of_avatar_id"
                                  class="image"
                                />
                              </a-col>
                            </a-row>
                          </a-col>
                          <a-col :span="18" class="content">
                            <a-row :gutter="[0, 4]">
                              <a-col :span="24">
                                <a-row
                                  type="flex"
                                  justify="space-between"
                                  align="middle"
                                >
                                  <a-col>
                                    <span
                                      v-if="
                                        item.seat_quantity &&
                                        item.seat_quantity !== null
                                      "
                                    >
                                      {{
                                        $t('js.xe_count_cho', { count: item.seat_quantity })
                                      }}
                                    </span>
                                  </a-col>
                                  <a-col>
                                    <span class="cost">{{
                                      `${formatNumber(
                                        parseInt(item.end_amount)
                                      )}đ`
                                    }}</span>
                                  </a-col>
                                </a-row>
                              </a-col>
                              <a-col :span="24">
                                <a-row
                                  type="flex"
                                  justify="space-between"
                                  align="middle"
                                >
                                  <a-col>
                                    <a-timeline>
                                      <a-timeline-item>
                                        <a-row
                                          type="flex"
                                          align="middle"
                                          :gutter="[8, 0]"
                                        >
                                          <a-col>
                                            <span class="time"
                                              >{{ getTime(item.start_time) }}
                                            </span></a-col
                                          >
                                          <a-col class="dot"> </a-col>
                                          <a-col>
                                            <span class="location">{{
                                              item.title_destination
                                            }}</span>
                                          </a-col>
                                        </a-row></a-timeline-item
                                      >
                                      <a-timeline-item>
                                        <template #dot
                                          ><ClockCircleOutlined
                                            style="font-size: 16px"
                                        /></template>
                                        <span class="time-total">{{
                                         `${getTime(item.total_time).replace(':','h')}'`
                                        }}</span>
                                      </a-timeline-item>
                                      <a-timeline-item>
                                        <a-row
                                          type="flex"
                                          align="middle"
                                          :gutter="[8, 0]"
                                        >
                                          <a-col>
                                            <span class="time"
                                              >{{ getTime(item.end_time) }}
                                            </span></a-col
                                          >
                                          <a-col class="dot"></a-col>
                                          <a-col>
                                            <span class="location">{{
                                              item.title_arrival
                                            }}</span>
                                          </a-col>
                                        </a-row>
                                      </a-timeline-item>
                                    </a-timeline>
                                  </a-col>
                                  <a-col>
                                    <span
                                      v-if="
                                        item.seat_quantity &&
                                        item.seat_quantity !== null
                                      "
                                      class="seats-empty"
                                      >{{
                                        $t('js.con_count_ghe_trong', { count: item.remain_seat_quantity })
                                      }}</span
                                    >
                                  </a-col>
                                </a-row>
                              </a-col>
                              <a-col :span="24">
                                <a-row
                                  type="flex"
                                  justify="space-between"
                                  align="middle"
                                >
                                  <a-col>
                                    <a-row
                                      type="flex"
                                      align="middle"
                                      :gutter="[8, 0]"
                                      @click="showDetailInfo(item)"
                                    >
                                      <a-col>
                                        <span class="detail-info-btn"
                                          >{{ $t('js.thong_tin_chi_tiet') }}</span
                                        >
                                      </a-col>
                                      <a-col>
                                        <UpOutlined
                                          style="color: rgb(0, 96, 196)"
                                          v-if="item.is_detail" />
                                        <DownOutlined
                                          style="color: rgb(0, 96, 196)"
                                          v-else
                                      /></a-col>
                                    </a-row>
                                  </a-col>
                                  <a-col>
                                    <a-button @click="showSelectSeats(item)">
                                      <span>{{
                                        item.is_select ? $t('js.dong') : $t('js.dat_ve')
                                      }}</span>
                                    </a-button>
                                  </a-col>
                                </a-row>
                              </a-col>
                            </a-row>
                          </a-col>
                        </a-row>
                      </a-col>
                      <a-col :span="20" :offset="2" v-if="item.is_select">
                        <Booking
                          :item="item"
                          :destinationLocation="destinationLocation"
                          :arrivalLocation="arrivalLocation"
                          :listDetailLoading="listDetailLoading"
                          :dateValue="dateValue"
                        ></Booking>
                      </a-col>
                      <a-col :span="20" :offset="2" v-if="item.is_detail">
                        <a-row>
                          <a-col :span="24">
                            <a-tabs v-model:activeKey="activeKey">
                              <a-tab-pane :key="0" :tab="$t('js.tien_ich')">
                                <div class="utility-container">
                                  <a-col class="utility-content">
                                    <a-row
                                      v-for="utility in utilities"
                                      :key="utility.id"
                                      :gutter="[0, 8]"
                                      class="utility-item"
                                      align="middle"
                                    >
                                      <a-col :span="24">
                                        <a-row :gutter="[8, 0]">
                                          <a-col>
                                            <component
                                              class="icon"
                                              :is="utility.icon"
                                            />
                                          </a-col>
                                          <a-col>
                                            <span class="title">{{
                                              utility.title
                                            }}</span>
                                          </a-col>
                                        </a-row>
                                      </a-col>
                                      <a-col
                                        :span="24"
                                        v-if="
                                          utility.description !== null &&
                                          utility.description !== ''
                                        "
                                      >
                                        <a-row>
                                          <span class="description">{{
                                            utility.description
                                          }}</span>
                                        </a-row>
                                      </a-col>
                                    </a-row>
                                  </a-col>
                                </div>
                              </a-tab-pane>
                              <a-tab-pane :key="1" :tab="$t('js.diem_don_tra')">
                                <a-col :span="24" class="location-tab">
                                  <a-row :gutter="[0, 16]">
                                    <a-col :span="24">
                                      <a-row :gutter="[8, 0]" align="middle">
                                        <a-col>
                                          <span class="title">{{ $t('js.luu_y_62856b8f') }}</span>
                                        </a-col>
                                        <a-col>
                                          <span
                                            >{{ $t('js.cac_moc_thoi_gian_don_tra_ben_duoi_la_thoi_gian_du_kien_lich_nay_co_the_130d22af') }}</span
                                          >
                                        </a-col>
                                      </a-row>
                                    </a-col>
                                    <a-col :span="24">
                                      <a-row>
                                        <a-col :span="12" class="item-content">
                                          <a-row :gutter="[0, 8]">
                                            <a-col :span="24"
                                              ><span class="title"
                                                >{{ $t('js.diem_don') }}</span
                                              ></a-col
                                            >
                                            <a-col
                                              v-if="
                                                destinationLocation.length ==
                                                  0 &&
                                                listDetailLoading == false
                                              "
                                              :span="24"
                                            >
                                              <a-row
                                                type="flex"
                                                justify="center"
                                                align="middle"
                                                style="min-height: 200px"
                                              >
                                                <a-empty
                                                  :description="$t('js.khong_co_diem_don_phu_hop')"
                                                />
                                              </a-row>
                                            </a-col>
                                            <a-col
                                              v-if="listDetailLoading"
                                              :span="24"
                                            >
                                              <a-skeleton active />
                                            </a-col>
                                            <a-col
                                              :span="24"
                                              class="location-radio"
                                              v-else
                                            >
                                              <a-row
                                                v-for="des in sortTime(destinationLocation)"
                                                :key="des.id"
                                                :gutter="[0, 16]"
                                              >
                                                <a-col :span="24">
                                                  <span>
                                                    <img
                                                      class="location-img"
                                                      :src="
                                                        require('@/assets/img/location.png')
                                                          .default
                                                      "
                                                      alt=""
                                                    />
                                                    <b>
                                                      {{ getTime(des.time) }}
                                                    </b>
                                                    -
                                                    <span
                                                      :class="[
                                                        des.is_transit == 1
                                                          ? 'transit'
                                                          : '',
                                                      ]"
                                                      >{{ des.title }}</span
                                                    >
                                                  </span>
                                                </a-col>
                                              </a-row>
                                            </a-col>
                                          </a-row>
                                        </a-col>
                                        <a-col :span="12" class="item-content">
                                          <a-row :gutter="[0, 8]">
                                            <a-col :span="24"
                                              ><span class="title"
                                                >{{ $t('js.diem_tra') }}</span
                                              ></a-col
                                            >
                                            <a-col
                                              v-if="
                                                arrivalLocation.length == 0 &&
                                                listDetailLoading == false
                                              "
                                              :span="24"
                                            >
                                              <a-row
                                                type="flex"
                                                justify="center"
                                                align="middle"
                                                style="min-height: 200px"
                                              >
                                                <a-empty
                                                  :description="$t('js.khong_co_diem_tra_phu_hop')"
                                                />
                                              </a-row>
                                            </a-col>
                                            <a-col
                                              v-if="listDetailLoading"
                                              :span="24"
                                            >
                                              <a-skeleton active />
                                            </a-col>
                                            <a-col
                                              :span="24"
                                              class="location-radio"
                                              v-else
                                            >
                                              <a-row
                                                v-for="arr in sortTime(arrivalLocation)"
                                                :key="arr.id"
                                                :gutter="[0, 16]"
                                              >
                                                <a-col :span="24">
                                                  <span>
                                                    <img
                                                      class="location-img"
                                                      :src="
                                                        require('@/assets/img/location.png')
                                                          .default
                                                      "
                                                      alt=""
                                                    />
                                                    <b>
                                                      {{ getTime(arr.time) }}
                                                    </b>
                                                    -
                                                    <span
                                                      :class="[
                                                        arr.is_transit == 1
                                                          ? 'transit'
                                                          : '',
                                                      ]"
                                                      >{{ arr.title }}</span
                                                    >
                                                  </span>
                                                </a-col>
                                              </a-row>
                                            </a-col>
                                          </a-row>
                                        </a-col>
                                      </a-row>
                                    </a-col>
                                  </a-row>
                                </a-col>
                              </a-tab-pane>
                              <!-- <a-tab-pane :key="2" :tab="$t('js.chinh_sach')">
                                <a-row :gutter="[0, 16]">
                                  <a-col :span="24">
                                    <span>{{ $t('js.phi_huy') }}</span>
                                  </a-col>
                                  <a-col :span="24">
                                    <a-row :gutter="[8, 0]">
                                      <a-col>
                                        <span> {{ $t('js.ghi_chu_cb3392b9') }} </span>
                                      </a-col>
                                      <a-col>
                                        <span>
                                          Phí huỷ sẽ được tính trên giá gốc,
                                          không giảm trừ khuyến mãi hoặc giảm
                                          giá; đồng thời không vượt quá số tiền
                                          quý khách đã thanh toán.</span
                                        >
                                      </a-col>
                                    </a-row>
                                  </a-col>
                                </a-row>
                              </a-tab-pane> -->
                              <a-tab-pane :key="2" :tab="$t('js.danh_gia')">
                                <a-row
                                  type="flex"
                                  justify="center"
                                  align="middle"
                                  class="rate"
                                >
                                  <a-col>
                                    <a-empty
                                      :description="$t('js.hien_nay_chung_toi_khong_co_danh_gia_nao_ca')"
                                    />
                                  </a-col>
                                </a-row>
                              </a-tab-pane>
                            </a-tabs>
                          </a-col>
                        </a-row>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row type="flex" justify="center" align="end">
                  <a-col>
                    <a-pagination
                      v-model:current="page"
                      :total="totalItem"
                      :show-total="
                        (total, range) =>
                          $t('js.from_to_total_tuyen', {
                            from: range[0], to: range[1], total
                          })
                      "
                      :pageSize="10"
                      show-less-items
                    />
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="6">
            <a-row type="flex" justify="center" class="filter">
              <a-col :span="24" class="filter-search">
                <a-row type="flex" justify="space-between" align="middle">
                  <a-col>
                    <span class="text-filter-search">{{ $t('js.bo_loc_tim_kiem') }}</span>
                  </a-col>
                  <a-col @click="delFilter">
                    <span class="del-filter">{{ $t('js.xoa_loc') }}</span>
                  </a-col>
                </a-row>
              </a-col>
              <a-col :span="24" class="filter-content">
                <a-row class="filter-item">
                  <a-col :span="24" class="child-item">
                    <a-row>
                      <span class="title">{{ $t('js.gio_di') }}</span>
                    </a-row>
                    <a-row>
                      <a-col :span="24">
                        <a-slider
                          range
                          :tip-formatter="formatTime"
                          :step="0.01"
                          :min="0"
                          :max="23.59"
                          v-model:value="destinationTime"
                        />
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="space-between">
                      <a-col>
                        <span>{{ formatTime(destinationTime[0]) }}</span>
                      </a-col>
                      <a-col
                        ><span>{{ formatTime(destinationTime[1]) }}</span>
                      </a-col>
                    </a-row>
                  </a-col>
                  <a-col :span="24" class="child-item">
                    <a-row>
                      <span class="title">{{ $t('js.gia_ve') }}</span>
                    </a-row>
                    <a-row>
                      <a-col :span="24">
                        <a-slider
                          range
                          :tip-formatter="formatNumber"
                          :step="10000"
                          :min="0"
                          :max="2000000"
                          v-model:value="ticketCost"
                        />
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="space-between">
                      <a-col>
                        <span>{{ `${formatNumber(ticketCost[0])}đ` }}</span>
                      </a-col>
                      <a-col
                        ><span>{{ `${formatNumber(ticketCost[1])}đ` }}</span>
                      </a-col>
                    </a-row>
                  </a-col>
                  <a-col :span="24" class="child-item">
                    <a-row>
                      <span class="title">{{ $t('js.so_cho_trong') }}</span>
                    </a-row>
                    <a-row>
                      <a-col :span="24">
                        <a-slider
                          range
                          :min="0"
                          :max="50"
                          v-model:value="amountSeatEmpty"
                        />
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="space-between">
                      <a-col>
                        <span>{{ amountSeatEmpty[0] }}</span>
                      </a-col>
                      <a-col
                        ><span>{{ amountSeatEmpty[1] }}</span>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row class="filter-item">
                  <a-col :span="24" class="child-item">
                    <span class="title">{{ $t('js.diem_don') }}</span>
                  </a-col>
                  <a-col :span="24" class="child-item">
                    <a-input-search
                      v-model:value="destinationSearch"
                      :placeholder="$t('js.nhap_diem_don')"
                      enter-button
                      @change="
                        changeTextSearch('destination', destinationSearch)
                      "
                      @search="
                        onSearch(
                          'destination',
                          'province_destination_title',
                          desLocation,
                          destinationSearch
                        )
                      "
                    />
                  </a-col>
                  <a-col :span="24" class="child-item">
                    <a-radio-group v-model:value="destinationValue">
                      <a-row :gutter="[0, 8]">
                        <a-col
                          v-for="location in desSearchData"
                          :key="location.province_destination_id"
                          :span="24"
                        >
                          <a-radio :value="location.province_destination_id"
                            ><span>{{
                              location.province_destination_title
                            }}</span></a-radio
                          >
                        </a-col>
                      </a-row>
                    </a-radio-group>
                  </a-col>
                </a-row>
                <a-row class="filter-item">
                  <a-col :span="24" class="child-item">
                    <span class="title">{{ $t('js.diem_tra') }}</span>
                  </a-col>
                  <a-col :span="24" class="child-item">
                    <a-input-search
                      v-model:value="arrivalSearch"
                      :placeholder="$t('js.nhap_diem_tra')"
                      enter-button
                      @change="changeTextSearch('arrival', arrivalSearch)"
                      @search="
                        onSearch(
                          'arrival',
                          'province_arrival_title',
                          arrLocation,
                          arrivalSearch
                        )
                      "
                    />
                  </a-col>
                  <a-col :span="24" class="child-item">
                    <a-radio-group v-model:value="arrivalValue">
                      <a-row :gutter="[0, 8]">
                        <a-col
                          v-for="location in arrSearchData"
                          :key="location.province_arrival_id"
                          :span="24"
                        >
                          <a-radio :value="location.province_arrival_id"
                            ><span>{{
                              location.province_arrival_title
                            }}</span></a-radio
                          >
                        </a-col>
                      </a-row>
                    </a-radio-group>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>
<script setup>
import { computed, onMounted, ref, watch } from "vue";
import moment, { Moment } from "moment";
import Booking from "./Booking.vue";
import { formatNumber, formatTime, renderImg } from "@/utility";
import { datePickerLocale as locale } from "@/common/locale";
import {
  DownOutlined,
  UpOutlined,
  LeftOutlined,
  ClockCircleOutlined,
  LeftCircleOutlined,
  RightCircleOutlined,
  AimOutlined,
  AppstoreOutlined,
  BarcodeOutlined,
  NotificationOutlined,
  NodeIndexOutlined
} from "@ant-design/icons-vue";
import TicketReservationsService from "@/services/TicketReservationsService";
import { message, Modal } from "ant-design-vue";
const domain = ref(window.location.href);
const desLocation = ref([]);
const arrLocation = ref([]);
const activeKey = ref(0);
const destinationValue = ref();
const arrivalValue = ref();
const dateFormat = "DD/MM/YYYY";
const today = new Date();
const dateValue = ref(moment(today), dateFormat);
const checked = ref(false);
const destinationTime = ref([0, 23.59]);
const ticketCost = ref([0, 2000000]);
const amountSeatEmpty = ref([0, 50]);
const destinationSearch = ref("");
const desSearchData = ref("");
const arrivalSearch = ref([]);
const arrSearchData = ref([]);
const sortValue = ref(0);
const listLoading = ref(false);
const listDetailLoading = ref(false);
const sortField = ref("start_time");
const sortType = ref("asc");
const dataSource = ref([]);
const roadDetailData = ref([]);
const page = ref(1);
const totalItem = ref(0);
const params = computed(() => {
  let startTime = "";
  if (destinationTime.value[0] == 0) {
    startTime = "0" + destinationTime.value[0].toString() + ":00:00";
  } else {
    startTime = destinationTime.value[0].toString().replace(".", ":") + ":00";
  }
  let data = {
    location_destination_id: destinationValue.value,
    location_arrival_id: arrivalValue.value,
    depart_date: dateValue.value.format("YYYY-MM-DD"),
    seat_from: amountSeatEmpty.value[0],
    seat_to: amountSeatEmpty.value[1],
    start_time_from: startTime,
    start_time_to:
      destinationTime.value[1].toString().replace(".", ":") + ":00",
    amount_from: ticketCost.value[0],
    amount_to: ticketCost.value[1],
    sort_field: sortField.value,
    sort_type: sortType.value,
    page: page.value,
  };
  return data;
});
const destinationLocation = computed(() => {
  let data = [];
  if (roadDetailData.value.length > 0) {
    data = roadDetailData.value.filter((e) => e.is_destination == 1);
  }
  return data;
});
const arrivalLocation = computed(() => {
  let data = [];
  if (roadDetailData.value.length > 0) {
    data = roadDetailData.value.filter((e) => e.is_arrival == 1);
  }
  return data;
});
const utilities = ref([
  {
    id: 0,
    title: window.__t('js.xem_vi_tri_xe_truc_tuyen'),
    description:
      window.__t('js.cho_phep_hanh_khach_nhin_thay_duoc_lo_trinh_va_thoi_gian_di_chuyen_cua_c5f97831'),
    icon: AimOutlined,
  },
  {
    id: 1,
    title: window.__t('js.rem_cua'),
    description: "",
    icon: BarcodeOutlined,
  },
  {
    id: 2,
    title: window.__t('js.dan_am_thanh_loa'),
    description: "",
    icon: NotificationOutlined,
  },
  {
    id: 3,
    title: window.__t('js.day_dai_an_toan'),
    description:
      window.__t('js.tren_xe_co_trang_bi_day_dai_an_toan_cho_hanh_khach_khi_ngoi_tren_xe'),
    icon: NodeIndexOutlined,
  },
]);
const logo = ref({
  backgroundImage: "url(" + require("@/assets/img/full_blue.png").default + ")",
  backgroundRepeat: "no-repeat",
});
onMounted(() => {
  getProvinces();
});
const getListRoad = () => {
  listLoading.value = true;
  TicketReservationsService.getListRoad(params.value)
    .then((res) => {
      if (res.data.errorCode == 0) {
        dataSource.value = res.data.data.data;
        totalItem.value = res.data.data.total;
        listLoading.value = false;
      } else {
        dataSource.value = [];
        message.error(window.__t('js.loi_he_thong'));
        registerLoading.value = false;
        listLoading.value = false;
      }
    })
    .catch((error) => {
      dataSource.value = [];
      message.error(error.message);
      listLoading.value = false;
    });
};
const getListDetail = (id) => {
  listDetailLoading.value = true;
  TicketReservationsService.getListDetail(id)
    .then((res) => {
      if (res.data.errorCode == 0) {
        roadDetailData.value = res.data.data;
        listDetailLoading.value = false;
      } else {
        roadDetailData.value = [];
        message.error(window.__t('js.loi_he_thong'));
        listDetailLoading.value = false;
      }
    })
    .catch((error) => {
      roadDetailData.value = [];
      message.error(error.message);
      listDetailLoading.value = false;
    });
};
const getProvinces = () => {
  TicketReservationsService.getProvinces()
    .then((res) => {
      if (res.data.errorCode == 0) {
        desLocation.value = res.data.data.des_location;
        desSearchData.value = res.data.data.des_location;
        arrLocation.value = res.data.data.arr_location;
        arrSearchData.value = res.data.data.arr_location;
        getData();
        getListRoad();
      } else {
        desLocation.value = [];
        arrLocation.value = [];
        message.error(window.__t('js.loi_he_thong'));
      }
    })
    .catch((error) => {
      desLocation.value = [];
      arrLocation.value = [];
      message.error(error.message);
    });
};
const getData = () => {
  let attributes = domain.value.split("?")[1].split(",");
  let data = [];
  attributes.forEach((e) => {
    data.push(e.split("=")[1]);
  });
  destinationValue.value = data[0];
  arrivalValue.value = data[1];
  if (data[2]) {
    dateValue.value = moment(data[2], "DD-MM-YYYY");
  }
};
const sort = () => {
  switch (sortValue.value) {
    case 0:
      sortField.value = "start_time";
      sortType.value = "asc";
      break;
    case 1:
      sortField.value = "start_time";
      sortType.value = "desc";
      break;
    case 2:
      sortField.value = "end_amount";
      sortType.value = "asc";
      break;
    case 3:
      sortField.value = "end_amount";
      sortType.value = "desc";
      break;
  }
  getListRoad();
};
const changeTextSearch = (type, textSearch) => {
  if (type == "destination" && textSearch == "") {
    desSearchData.value = desLocation.value;
  } else if (type == "arrival" && textSearch == "") {
    arrSearchData.value = arrLocation.value;
  }
};
const onSearch = (type, atributes, dataSearch, textSearch) => {
  if (textSearch == "") {
    if (type == "destination") {
      desSearchData.value = desLocation.value;
    } else if (type == "arrival") {
      arrSearchData.value = arrLocation.value;
    }
  } else {
    let data = dataSearch.filter((p) =>
      p[atributes]
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .includes(
          textSearch
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
        )
    );
    if (type == "destination") {
      desSearchData.value = data;
    } else if (type == "arrival") {
      arrSearchData.value = data;
    }
  }
};
const getTime = (time) => {
  return time.slice(0, 5);
};
const prevPage = () => {
  page.value--;
  getListRoad();
};
const nextPage = () => {
  page.value++;
  getListRoad();
};
const changeDes = (value, option) => {
  destinationValue.value = value;
};
const changeArr = (value, option) => {
  arrivalValue.value = value;
};
const showSelectSeats = (item) => {
  dataSource.value.forEach((e) => {
    if (e.id == item.id) {
      if (e.is_detail == true) {
        e.is_detail = false;
      }
      e.is_select = !e.is_select;
    } else {
      e.is_select = false;
      e.is_detail = false;
    }
  });
  getListDetail(item.road_id);
};
const renderOption = (type, array, properties) => {
  let data = [];
  array.forEach((e) => {
    data.push({
      id:
        type == "destination"
          ? e.province_destination_id
          : e.province_arrival_id,
      value:
        type == "destination"
          ? e.province_destination_id
          : e.province_arrival_id,
      label: e[properties],
    });
  });
  return data;
};
const sortTime = (array) =>{
 return array.sort((a,b) => a.time.localeCompare(b.time));
}
const showDetailInfo = (item) => {
  activeKey.value = 0;
  dataSource.value.forEach((e) => {
    if (e.id == item.id) {
      if (e.is_select == true) {
        e.is_select = false;
      }
      e.is_detail = !e.is_detail;
    } else {
      e.is_select = false;
      e.is_detail = false;
    }
  });
  getListDetail(item.road_id);
};
const delFilter = () => {
  destinationTime.value = [0, 23.59];
  ticketCost.value = [0, 2000000];
  amountSeatEmpty.value = [0, 50];
};
</script>
<style scoped lang="scss">
.logo-dashboard {
  width: 185px;
  height: 48px;
  margin-left: 16px;
  margin-top: 8px;
  float: left;
  -webkit-background-size: contain;
  background-size: contain;
}
.text-primary {
  color: rgb(0, 96, 196);
}
.container {
  .header-container {
    padding: 24px 0px 24px 0px;
    .header-content {
      .header-item {
        padding: 0px 16px 0px 16px;
        height: 100%;
        .title-input {
          color: #585859;
          font-weight: 700;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 8px;
        }
        .ant-select {
          width: 100%;
          :deep(.ant-select-selector) {
            width: 100%;
            height: 48px;
            border-radius: 6px;
            border: 1px solid #bdbdbf;
            color: #585859;
            font-size: 16px;
            line-height: 18px;
            align-items: center;
          }
        }
        .ant-calendar-picker {
          :deep(.ant-calendar-picker-input.ant-input) {
            width: 100%;
            height: 48px;
            border-radius: 6px;
            border: 1px solid #bdbdbf;
            color: #585859;
            font-size: 16px;
            line-height: 18px;
            align-items: center;
          }
        }
        .ant-btn-primary {
          height: 48px;
          border-radius: 6px;
          background-color: #ffcf22;
          width: 100%;
          border-color: #ffcf22;
          .text-search {
            color: #585859;
            font-weight: 700;
            font-size: 20px;
            line-height: 25px;
            letter-spacing: 0.4px;
          }
        }
      }
    }
  }
  .content-container {
    background: #f8f8fa;
    padding: 24px 0px 24px 0px;
    .title {
      color: #484848;
      font-weight: 700;
    }
    .content {
      .filter {
        margin: 0px 16px 0px 16px;
        .filter-search {
          .text-filter-search {
            font-weight: 700;
            font-size: 16px;
          }
          .del-filter {
            color: rgb(0, 96, 196);
          }
        }
        .filter-content {
          width: 100%;
          padding: 16px;
          margin-top: 16px;
          font-size: 14px;
          border: 1px solid silver;
          border-radius: 6px;
          .filter-item {
            margin-bottom: 16px;
            .child-item {
              padding: 8px 0px 8px 0px;
              .ant-slider {
                :deep(.ant-slider-track) {
                  background: #0060c4;
                }
                :deep(.ant-slider-handle) {
                  border-color: #1890ff;
                }
              }
              .ant-input-search {
                :deep(.ant-btn-primary) {
                  background: white;
                  border: 1px solid #d9d9d9;
                }
                :deep(.anticon-search) {
                  color: silver;
                }
              }
            }
          }
        }
      }
      .list {
        margin: 0px 16px 0px 16px;
        .sort-btn {
          .ant-radio-group {
            :deep(.ant-radio-button-wrapper-checked) {
              background: #0060c4;
              border-color: #0060c4 !important;
            }
          }
        }
        .list-empty {
          min-height: 60vh;
        }
        .list-content {
          .ant-pagination {
            :deep(.ant-pagination-item-active) {
              border-color: #0060c4;
              a {
                color: #0060c4;
              }
            }
          }
          .image-container {
            .image {
              width: 200px;
              height: 200px;
            }
          }
          margin-top: 8px;
          .item-list {
            padding: 8px 16px 8px 16px;
            margin-bottom: 8px;
            border-radius: 6px;

            background: #ffffff;
            .item-list-content {
              padding-bottom: 16px;
              border-bottom: 1px solid silver;
            }
            .content {
              .seats-empty {
                font-size: 16px;
                color: #484848;
              }
              .detail-info-btn {
                font-size: 16px;
                color: rgb(0, 96, 196);
              }
              .cost {
                font-size: 16px;
                font-weight: bold;
                display: inline-block;
                width: 100%;
                color: rgb(0, 96, 196);
              }
              .ant-timeline {
                .ant-timeline-item {
                  :deep(.ant-timeline-item-content) {
                    .time {
                      font-size: 20px;
                      font-weight: 700;
                      margin-right: 4px;
                      color: #484848;
                    }
                    .location {
                      font-size: 16px;
                      color: #000;
                    }
                    .dot {
                      width: 8px;
                      height: 8px;
                      background: black;
                      border-radius: 50%;
                    }
                    .time-total {
                      font-size: 14px;
                    }
                  }
                }
                .ant-timeline-item-last {
                  padding-bottom: 0;
                }
              }
            }

            // margin-top: 24px;
            .ant-tabs-line {
              :deep(.ant-tabs-nav-scroll) {
                display: flex;
                justify-content: center;
              }
            }
            .utility-container {
              .utility-content {
                background: #f5f5f5;
                padding: 0px 12px 0px 12px;
                .utility-item {
                  padding: 12px 0px 12px 0px;
                  border-bottom: 1px solid silver;
                  min-height: 24px;
                  .text-title {
                    font-size: 16px;
                    font-weight: 600;
                  }
                  .text {
                    font-size: 16px;
                  }
                  .title {
                    font-size: 14;
                  }
                  .description {
                    font-size: 14;
                  }
                  .icon {
                    font-size: 24px;
                    color: #ffcf22;
                  }
                }
              }
            }
            .location-tab {
              margin-bottom: 8px;
              .title {
                font-size: 16px;
                font-weight: 600;
              }
              .title-input {
                font-size: 14px;
                font-weight: 700;
                line-height: 17px;
              }
              .title-hot-input {
                font-size: 14px;
                font-weight: 700;
                line-height: 17px;
                color: red;
              }
              .item-content {
                padding-left: 20px;
                padding-right: 20px;
                .title {
                  font-weight: 700;
                  font-size: 18px;
                  text-align: left;
                }
                .location-radio {
                  height: 200px;
                  overflow: scroll;
                  overflow-x: hidden;
                  font-size: 16px;
                  .transit {
                    color: #0060c4;
                  }
                  .dot {
                    background: black;
                    width: 4px;
                    height: 4px;
                    border-radius: 50%;
                  }
                  .time {
                    font-weight: 600;
                  }
                  .location-img {
                    width: 24px;
                    position: relative;
                    bottom: 2px;
                  }
                }
              }
            }
            .rate {
              min-height: 240px;
            }
          }
        }
      }
    }
  }
}
</style>
